import React, { useState, useEffect } from 'react';
import '../styles/OnboardingDemoModal.css';

const POST_TASK_DEMO_STEPS = [
    {
        title: "1. Kategori ve Hizmet Seç",
        desc: "Ana sayfadaki arama çubuğunu kullanarak veya kategorilere göz atarak ihtiyacın olan hizmeti seç.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-search-box">
                    <span className="demo-search-icon">🔍</span>
                    <span className="demo-search-placeholder">Hangi hizmete ihtiyacınız var?</span>
                </div>
                <div className="demo-category-chips">
                    <span className="demo-chip active">Temizlik</span>
                    <span className="demo-chip">Tadilat</span>
                    <span className="demo-chip">Nakliye</span>
                </div>
            </div>
        )
    },
    {
        title: "2. Detayları Belirle",
        desc: "Hizmetin ne zaman ve nerede yapılacağını seç, işin detaylarını açıklama kısmına yaz.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-form">
                    <div className="demo-input-group">
                        <label>📍 Konum</label>
                        <div className="demo-input">İstanbul, Kadıköy</div>
                    </div>
                    <div className="demo-input-group">
                        <label>📅 Tarih</label>
                        <div className="demo-input">15 Mart 2026</div>
                    </div>
                    <div className="demo-input-group">
                        <label>📝 Açıklama</label>
                        <div className="demo-textarea">Evin genel temizliği yapılacak. 3 oda 1 salon...</div>
                    </div>
                </div>
            </div>
        )
    },
    {
        title: "3. İlanını Yayınla",
        desc: "Bilgileri kontrol et ve 'İlanı Yayınla' butonuna bas. İlanın yayınlandığında hizmet verenlere bildirim gidecek!",
        visual: (
            <div className="demo-mockup">
                <div className="demo-cta-area">
                    <button className="demo-cta-btn">🚀 İlanı Yayınla</button>
                    <p className="demo-cta-note">İlanınız onaylandıktan sonra teklifler gelmeye başlar.</p>
                </div>
            </div>
        )
    }
];

const OFFER_DEMO_STEPS = [
    {
        title: "1. Teklif Kartını Gör",
        desc: "Gelen Teklifler sekmesinde, her teklif bir kart olarak listelenir. Kartın üstünde kategori, hizmet sağlayıcının adı ve teklif fiyatı görünür.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-card">
                    <div className="demo-card-header">
                        <span className="demo-tag">Ev Temizliği</span>
                        <span className="demo-price">2.000,00 ₺</span>
                    </div>
                    <div className="demo-card-body">
                        <p className="demo-provider-name">Ahmet Y.</p>
                        <p className="demo-meta">⭐ 4.8 · 12 değerlendirme</p>
                        <p className="demo-meta">📍 İstanbul / Kadıköy</p>
                        <p className="demo-meta">📅 15.03.2026</p>
                    </div>
                    <div className="demo-card-footer">
                        <span className="demo-highlight-btn">İncele →</span>
                    </div>
                </div>
            </div>
        )
    },
    {
        title: "2. Teklif Detayını İncele",
        desc: "Karta tıkladığında detay paneli açılır. Burada ilanınla ilgili tüm bilgileri göreceksin:",
        visual: (
            <div className="demo-mockup">
                <div className="demo-detail-panel">
                    <div className="demo-detail-row">
                        <span className="demo-label">📅 Hizmet Tarihi</span>
                        <span className="demo-value">15.03.2026, 10:00</span>
                    </div>
                    <div className="demo-detail-row">
                        <span className="demo-label">📍 Adres</span>
                        <span className="demo-value">Kadıköy, İstanbul</span>
                    </div>
                    <div className="demo-detail-row">
                        <span className="demo-label">📝 Açıklama</span>
                        <span className="demo-value">2+1 ev, pencereler dahil...</span>
                    </div>
                </div>
            </div>
        )
    },
    {
        title: "3. Hizmet Sağlayıcı Bilgileri",
        desc: "Teklifi gönderen hizmet sağlayıcının profil bilgilerini, istatistiklerini ve değerlendirmelerini incele.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-detail-panel">
                    <div className="demo-provider-card">
                        <div className="demo-avatar">AY</div>
                        <div>
                            <p className="demo-provider-name">Ahmet Y.</p>
                            <p className="demo-meta">⭐ 4.8 puan</p>
                        </div>
                    </div>
                    <div className="demo-stats-grid">
                        <div className="demo-stat">
                            <span className="demo-stat-num">24</span>
                            <span className="demo-stat-label">Tamamlanan İş</span>
                        </div>
                        <div className="demo-stat">
                            <span className="demo-stat-num">1</span>
                            <span className="demo-stat-label">İptal</span>
                        </div>
                        <div className="demo-stat">
                            <span className="demo-stat-num">12</span>
                            <span className="demo-stat-label">Değerlendirme</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    },
    {
        title: "4. Teklif Notu",
        desc: "Hizmet sağlayıcının teklifiyle birlikte gönderdiği notu oku. Genellikle yapacağı işin detaylarını, hangi malzemeleri getireceğini veya özel koşullarını burada belirtir.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-note">
                    <p className="demo-note-label">💬 Teklif Notu</p>
                    <p className="demo-note-text">"Merhaba, ev temizliğinde 5 yıl tecrübem var. Tüm temizlik malzemeleri tarafımdan karşılanır. Pencere temizliği dahildir."</p>
                </div>
            </div>
        )
    },
    {
        title: "5. Ödeme Özeti",
        desc: "Hizmet bedeli, KDV ve platform hizmetleri dahil toplam tutarı görebilirsiniz. Ödemenin tamamı iyzico güvencesiyle havuz hesabına alınır.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-detail-panel">
                    <div className="demo-detail-row total">
                        <span className="demo-label">Ödenecek Toplam Tutar</span>
                        <span className="demo-value" style={{ fontSize: '1.4rem' }}>2.240,00 ₺</span>
                    </div>
                    <p className="demo-pricing-mini">
                        * Bu tutar iş tamamlanana kadar güvenli havuzda bekletilir.
                    </p>
                </div>
            </div>
        )
    },
    {
        title: "6. Sözleşme Onayı",
        desc: "Teklifi kabul etmeden önce gerekli sözleşmeleri onaylaman gerekir. Onaylanmamış sözleşmeler varsa butonlar aktif olmaz.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-contracts">
                    <div className="demo-contract-item done">
                        <span>✓</span> KVKK Aydınlatma Metni
                    </div>
                    <div className="demo-contract-item done">
                        <span>✓</span> Açık Rıza Beyanı
                    </div>
                    <div className="demo-contract-item pending">
                        <span>○</span> Hizmet Alan Sözleşmesi
                    </div>
                    <div className="demo-contract-item pending">
                        <span>○</span> Mesafeli Satış Sözleşmesi
                    </div>
                    <p className="demo-contract-warn">⚠ Tüm sözleşmeleri onaylayınca butonu aktif olur.</p>
                </div>
            </div>
        )
    },
    {
        title: "7. Ödemeye Geç",
        desc: "Tüm sözleşmeleri onayladıktan sonra 'Ödemeye Geç' butonuna basarak ödeme adımına ilerle. Ödemen onaylanana kadar güvenli havuzda bekletilir.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-cta-area">
                    <div className="demo-cta-info">
                        <p>Toplam: <strong>2.240,00 ₺</strong></p>
                    </div>
                    <button className="demo-cta-btn">Ödemeye Geç →</button>
                    <p className="demo-cta-note">Ödeme sonrası anlaşma oluşur ve işlerim paneline düşer.</p>
                </div>
            </div>
        )
    }
];

const JOB_DEMO_STEPS = [
    {
        title: "1. İşlerim Sayfası",
        desc: "Anlaşma oluştuktan sonra iş 'İşlerim' sayfasında görünür. Aktif, tamamlanmış ve iptal edilmiş işlerini buradan takip edersin.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-jobs-overview">
                    <div className="demo-job-card active">
                        <span className="demo-tag">Ev Temizliği</span>
                        <p className="demo-provider-name">Ahmet Y.</p>
                        <p className="demo-meta">📅 15.03.2026 · 📍 Kadıköy</p>
                        <span className="demo-status active">Aktif</span>
                    </div>
                </div>
            </div>
        )
    },
    {
        title: "2. İş Detayı & İletişim",
        desc: "İş kartına tıklayarak detayları gör. Hizmet sağlayıcıyla mesajlaşma butonuna basarak iletişime geçebilirsin.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-detail-panel">
                    <div className="demo-detail-row">
                        <span className="demo-label">📞 İletişim</span>
                        <span className="demo-value">+90 5** *** ** **</span>
                    </div>
                    <div className="demo-detail-row">
                        <span className="demo-label">📧 E-posta</span>
                        <span className="demo-value">a***@email.com</span>
                    </div>
                    <button className="demo-chat-btn">💬 Mesaj Gönder</button>
                </div>
            </div>
        )
    },
    {
        title: "3. İş Tamamlama",
        desc: "Hizmet tamamlandığında 'İşi Tamamla' butonuna basarak işi kapatabilirsin. Her iki tarafın da onay vermesi gerekir.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-cta-area">
                    <p className="demo-cta-info">Hizmet tamamlandıysa onaylayın:</p>
                    <button className="demo-cta-btn complete">✓ İşi Tamamla</button>
                    <p className="demo-cta-note">Her iki taraf da onay verince iş kapanır.</p>
                </div>
            </div>
        )
    },
    {
        title: "4. Değerlendirme",
        desc: "İş tamamlandıktan sonra karşı tarafı puanlayıp yorum bırakabilirsin. Bu herkesin daha iyi hizmet almasını sağlar.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-review">
                    <div className="demo-stars">⭐⭐⭐⭐⭐</div>
                    <p className="demo-review-text">"Çok titiz ve zamanında geldi. Kesinlikle tavsiye ederim!"</p>
                    <button className="demo-cta-btn review">Değerlendirmeyi Gönder</button>
                </div>
            </div>
        )
    }
];

const BROWSE_TASKS_DEMO_STEPS = [
    {
        title: "1. İlanları Listele",
        desc: "Hizmet verdiğin kategorilerdeki tüm güncel ilanları buradan görebilirsin.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-search-box">
                    <span className="demo-search-icon">🔍</span>
                    <span className="demo-search-placeholder">İlan ara...</span>
                </div>
                <div className="demo-category-chips">
                    <span className="demo-chip active">Temizlik</span>
                    <span className="demo-chip">Boyacı</span>
                    <span className="demo-chip">Nakliye</span>
                </div>
            </div>
        )
    },
    {
        title: "2. Detaylı İnceleme",
        desc: "İlanın tarihini, konumunu ve müşteri açıklamasını inceleyerek sana en uygun işi seç.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-job-card">
                    <h4 className="demo-provider-name">Ev Temizliği (2+1)</h4>
                    <div className="demo-filters">
                        <span className="demo-filter-tag">📍 Beşiktaş</span>
                        <span className="demo-filter-tag">📅 Yarın</span>
                    </div>
                    <p className="demo-meta">"Pencereler ve balkon dahil detaylı temizlik istiyoruz."</p>
                </div>
            </div>
        )
    }
];

const SEND_OFFER_DEMO_STEPS = [
    {
        title: "1. Teklifini Hazırla",
        desc: "İş için vereceğin fiyatı ve müşteriye iletmek istediğin notu yaz.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-form">
                    <div className="demo-input-group">
                        <label>Teklif Fiyatın (₺)</label>
                        <div className="demo-input">1.500</div>
                    </div>
                    <div className="demo-input-group">
                        <label>Müşteriye Notun</label>
                        <div className="demo-textarea">Tüm malzemeler benden, profesyonel ekipmanlarla geliyorum.</div>
                    </div>
                </div>
            </div>
        )
    },
    {
        title: "2. Teklifi Gönder",
        desc: "Teklifini gönderdikten sonra müşteri seni değerlendirecek. Profilin ne kadar doluysa seçilme şansın o kadar artar!",
        visual: (
            <div className="demo-mockup">
                <div className="demo-cta-area">
                    <button className="demo-cta-btn">Teklifi Gönder</button>
                    <p className="demo-cta-note">Müşteri teklifini kabul ettiğinde bildirim alacaksın.</p>
                </div>
            </div>
        )
    }
];

const REVIEW_CUSTOMER_DEMO_STEPS = [
    {
        title: "1. Deneyimini Puanla",
        desc: "İş bittiğinde müşteriyi değerlendirerek topluluğa katkıda bulun.",
        visual: (
            <div className="demo-mockup">
                <div className="demo-review">
                    <div className="demo-stars">⭐⭐⭐⭐⭐</div>
                    <div className="demo-review-text">"Müşteri çok anlayışlıydı, işi tam zamanında bitirdik."</div>
                    <button className="demo-cta-btn review">Değerlendirmeyi Gönder</button>
                </div>
            </div>
        )
    }
];

const OnboardingDemoModal = ({ demoType, onClose }) => {
    const [currentStep, setCurrentStep] = useState(0);

    // Reset step when modal opens/changes type
    useEffect(() => {
        setCurrentStep(0);
    }, [demoType]);

    if (!demoType) return null;

    const getSteps = () => {
        switch (demoType) {
            case 'post_task': return POST_TASK_DEMO_STEPS;
            case 'offers': return OFFER_DEMO_STEPS;
            case 'jobs': return JOB_DEMO_STEPS;
            case 'browse_tasks': return BROWSE_TASKS_DEMO_STEPS;
            case 'send_offer': return SEND_OFFER_DEMO_STEPS;
            case 'review_customer': return REVIEW_CUSTOMER_DEMO_STEPS;
            default: return [];
        }
    };

    const steps = getSteps();
    const totalSteps = steps.length;
    const step = steps[currentStep];

    if (!step) return null;

    const progress = ((currentStep + 1) / totalSteps) * 100;

    const handleNext = () => {
        if (currentStep < totalSteps - 1) setCurrentStep(prev => prev + 1);
    };

    const handlePrev = () => {
        if (currentStep > 0) setCurrentStep(prev => prev - 1);
    };

    const getModalTitle = () => {
        switch (demoType) {
            case 'post_task': return 'İlan Oluşturma';
            case 'offers': return 'Teklifleri İncele & Kabul Et';
            case 'jobs': return 'İş Sürecini Yönet';
            case 'browse_tasks': return 'Güncel İlanları İncele';
            case 'send_offer': return 'Teklif Verme';
            case 'review_customer': return 'Müşteriyi Değerlendir';
            default: return 'Nasıl Yapılır?';
        }
    };

    return (
        <div className="demo-overlay" onClick={onClose}>
            <div className="demo-modal" onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div className="demo-header">
                    <div>
                        <span className="demo-badge">DEMO</span>
                        <h3 className="demo-title">{getModalTitle()}</h3>
                    </div>
                    <button className="demo-close-btn" onClick={onClose}>✕</button>
                </div>

                {/* Progress */}
                <div className="demo-progress-bar">
                    <div className="demo-progress-fill" style={{ width: `${progress}%` }} />
                </div>

                {/* Step Content */}
                <div className="demo-content">
                    <h4 className="demo-step-title">{step.title}</h4>
                    <p className="demo-step-desc">{step.desc}</p>
                    {step.visual}
                </div>

                {/* Footer Navigation */}
                <div className="demo-footer">
                    <button
                        className="demo-nav-btn prev"
                        onClick={handlePrev}
                        disabled={currentStep === 0}
                    >
                        ← Geri
                    </button>
                    <span className="demo-step-indicator">
                        {currentStep + 1} / {totalSteps}
                    </span>
                    {currentStep < totalSteps - 1 ? (
                        <button className="demo-nav-btn next" onClick={handleNext}>
                            İleri →
                        </button>
                    ) : (
                        <button className="demo-nav-btn done" onClick={onClose}>
                            Anladım ✓
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OnboardingDemoModal;
